import styled, { css, keyframes } from 'styled-components';
const animationBase = css`
  animation-duration: 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
`;

const handAnimation = (startColor, endColor) => keyframes`
    0% {
      fill: ${startColor};
      transform: scale(1);
    }
    10% {
      transform: scale(0.75);
    }
    30% {
      transform: scale(0.75);
    }
    40% {
      transform: scale(1);
    }
    65% {
      fill: ${startColor};
    }
    75% {
      fill: ${endColor};
    }
    100% {
      fill: ${endColor};
    }
`;

export const AnimatedIcon = styled.svg`
  width: ${props => props.width || '32x'};
  height: ${props => props.height || '32px'};
`;
export const Hand = styled.path`
  animation-name: ${props => props.state !== 'animate' ? 'none' : handAnimation(props.theme.base.black, props.theme.base.red)};
  ${animationBase};
  transform-origin: center center;

  ${props => props.state === 'activated' && `
    color: ${props.theme.base.red};
  `}
`;

const sprinkleAnimation = (startColor, endColor) => keyframes`
    0% {
      stroke-dashoffset: 0;
      color: ${startColor};
    }
    10% {
      stroke-dashoffset: 9.5;
    }
    49% {
      stroke-dashoffset: 9.5;
      color: ${startColor};
    }
    50% {
      stroke-dashoffset: 8;
      color: ${endColor};
    }
    80% {
      color: ${endColor};
      stroke-dashoffset: 0;
    }
    100% {
      color: ${endColor};
      stroke-dashoffset: 0;
    }
`;

export const Sprinkle = styled.path`
  ${animationBase};
  stroke-dasharray: 9.5;
  animation-name: ${props => props.state !== 'animate' ? 'none' : sprinkleAnimation(props.theme.base.black, props.theme.base.red)};

  ${props => props.state === 'activated' && `
    color: ${props.theme.base.red};
  `}
`;